import { render, staticRenderFns } from "./AllReceiptVVP.vue?vue&type=template&id=657b0f02&scoped=true&"
import script from "./AllReceiptVVP.vue?vue&type=script&lang=js&"
export * from "./AllReceiptVVP.vue?vue&type=script&lang=js&"
import style0 from "./AllReceiptVVP.vue?vue&type=style&index=0&id=657b0f02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657b0f02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCol,VRow,VSimpleTable})
